import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function crucigramaComboReducer(state= initialState.crucigramaCombo, action){
	switch(action.type){
		case types.GET_CRUCIGRAMAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}